import H from 'constants/httpMethod.const';
import endpoint from 'utils/backend/endpoint.util';
import actionType from 'utils/mw/actionType.util';
import asObject from 'utils/objects/asObject.util';

const ATAG = 'beSaveTimeOffAllowance';
const AT = actionType(ATAG);

const beSaveTimeOffAllowance = (options) => {
  const { salonId, allowance, isNew } = asObject(options);

  return isNew
    ? endpoint(H.post, 'salon/v2/:salonId/time_off_allowances/', {
        AT,
        name: ATAG,
        params: { salonId },
        data: { ...allowance },
      })
    : endpoint(H.put, 'salon/v2/:salonId/time_off_allowances/:id/', {
        AT,
        name: ATAG,
        params: { salonId, id: allowance.id },
        data: { ...allowance },
      });
};

beSaveTimeOffAllowance.AT = AT;
beSaveTimeOffAllowance.ATAG = ATAG;

// noinspection JSUnusedGlobalSymbols
export default beSaveTimeOffAllowance;
